export default __webpack_public_path__ + "static/media/producteev.6bfea047.svg";